import React, { Component } from "react";
import {
  checkUser,
  login,
  validateOTP,
  reSendSMS,
  loginCoorparate,
  updatePassword,
  checkValidPassword,
  getPasswordCreteria,
} from "../api/api";
import { withTranslation } from "react-i18next";
import SuccessMessage from "./SuccessMessage";
import { Tooltip as ReactTooltip } from "react-tooltip";

class ResetPassword extends Component {
  showTooltip = false;
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: "",
      errors: { password: "", confirmPassword: "" },
      formIsValid: false,
      toolTipMessage: "",
    };
  }

  async componentDidMount() {
    let result = await getPasswordCreteria();
    const result1 = JSON.parse(result);
    
    const userPasswordRules = result1.data.user_password_rules_info;
    const descriptionArray = userPasswordRules.tool_tip_info.description;
    const criteriaArray = userPasswordRules.tool_tip_info.criteria_info;

    if (window.lang == "en") {
      let tooltipText = '';

      descriptionArray.length > 0 && descriptionArray.forEach((item) => {
          let arrayText = item.en === '' ? `${item.en}` : `${item.en}\n\n`;
          tooltipText += arrayText;
      });

      criteriaArray.length > 0 && criteriaArray.forEach(item => {
          let arrayText = `${item.en} \n\n`
          tooltipText += arrayText
      });

      const toolTipMessage_en = tooltipText;

      await this.setState({
        toolTipMessage: toolTipMessage_en,
      })
    } else if (window.lang == "ar") {
      let tooltipText = '';

      descriptionArray.length > 0 && descriptionArray.forEach((item) => {
          let arrayText = item.ar === '' ? `${item.ar}` : `${item.ar}\n\n`;
          tooltipText += arrayText;
      });

      criteriaArray.length > 0 && criteriaArray.forEach(item => {
          let arrayText = `${item.ar} \n\n`
          tooltipText += arrayText
      });

      const toolTipMessage_ar = tooltipText;

      await this.setState({
        toolTipMessage: toolTipMessage_ar,
      })
    }
  }

  handleClose = () => this.setState({ isSuccess: false });

  handaleSubmit = async (e) => {
    console.log("ResetPassword => handaleSubmit => Enter");
    console.log(
      "ResetPassword => handaleSubmit => formIsValid => " +
      this.state.formIsValid
    );

    e.preventDefault();
    if (this.state.formIsValid) {
      let result = await updatePassword(
        this.props.userName,
        this.state.password
      );
      console.log(
        "ResetPassword => handaleSubmit => result => " + JSON.stringify(result)
      );

      if (result.data.status !== 200) {
        console.log("success");

        this.setState({
          isSuccess: true,
        });
      }
    }
  };

  showHideTooltip = () => {
    // console.log("### !ReactTooltip : " + this.showTooltip);
    if (!this.showTooltip) {
      this.showTooltip = !this.showTooltip;
      return ReactTooltip.show(this.fooRef);
    } else {
      this.showTooltip = !this.showTooltip;
      return ReactTooltip.hide();
    }
  };

  handleConfirmPassword = (e) => {
    if (e.target.value === "") {
      this.state.errors.confirmPassword = "";
      this.setState({
        [e.target.name]: e.target.value,
        errors: { password: "", confirmPassword: "" },
      });
    }
    if (e.target.value !== this.state.password) {
      this.state.errors.confirmPassword = "password_not_match";
      this.setState({
        [e.target.name]: e.target.value,
        formIsValid: false,
      });
    } else {
      this.state.errors.confirmPassword = "";
      this.setState({
        [e.target.name]: e.target.value,
        formIsValid: this.state.errors.password === "" ? true : false,
      });
    }
  };

  handleChange = async (e) => {
    console.log("ResetPassword => handleChange => Enter");

    await this.setState({
      [e.target.name]: e.target.value,
    });
    let result = await checkValidPassword(
      this.props.userName,
      this.state.password
    );
    console.log("res => " + JSON.stringify(result));
    if (result.data != null && result.data.status == 200) {
      console.log("success");
      if (result.data.message !== "VALID_PASSWORD") {
        console.log("success");
        this.state.errors.password = "invalid_password";

        this.setState({
          formIsValid: false,
        });
      } else {
        this.state.errors.password = "";
        if (
          this.state.confirmPassword !== this.state.password &&
          this.state.confirmPassword !== ""
        ) {
          this.state.errors.confirmPassword = "password_not_match";
        } else {
          this.state.errors.confirmPassword = "";
        }
        this.setState({
          formIsValid:
            this.state.confirmPassword !== "" &&
              this.state.errors.confirmPassword === ""
              ? true
              : false,
        });
      }
    }
  };

  render() {
    const { t } = this.props;

    return (
      <div>
        <div className="loginPage">
          {!this.state.isSuccess && (
            <section className="login_form">
              <div className="loginIntroTextContainer">
                <h3>{t("reset_password_intro_title")}</h3>
                <p className="headerdescription">
                  {t("reset_password_intro_desc")}{" "}
                </p>
              </div>
              <div className="tabs">
                <div className="tab-content">
                  <form onSubmit={this.handaleSubmit} id="form-resetPassword">
                    {/* PASSWORD FIELD */}
                    <div
                      className={
                        "form-group " +
                        (this.state.errors.password ? "not-valid" : "")
                      }
                    >
                      <label className="input-label">{t("password")}</label>
                      <input
                        type="password"
                        name="password"
                        id="password"
                        className="form-control"
                        placeholder={t("password")}
                        value={this.state.password}
                        maxLength="50"
                        onChange={this.handleChange}
                      />
                      {
                        <div className="alert alert-danger" role="alert">
                          {t(this.state.errors.password)}{" "}
                          <a
                            data-tip={this.state.toolTipMessage}
                            data-event="click focus"
                          >
                            <i
                              aria-hidden="true"
                              className={
                                "fa fa-question-circle password-info" +
                                (window.lang !== "en"
                                  ? " fa-flip-horizontal"
                                  : "")
                              }
                              style={{
                                position: "absolute",
                                right: window.lang === "en" ? "0" : null,
                                left: window.lang !== "en" ? "0" : null,
                                bottom: "0.5rem",
                              }}
                            ></i>
                          </a>
                          <ReactTooltip
                            className={"multi-line-custome-" + window.lang}
                            data-html={true}
                            multiline={true}
                            globalEventOff="click"
                            data-text-color="white"
                            place="bottom"
                            effect="solid"
                            backgroundColor="#00467f"
                            style={{
                              maxWidth: "399px",
                              right: window.lang === "en" ? "0" : null,
                              left: window.lang !== "en" ? "0" : null,
                            }}
                          />
                        </div>
                      }
                    </div>

                    {/* CONFIRM PASSWORD FIELD */}
                    <div
                      className={
                        "form-group " +
                        (this.state.errors.confirmPassword ? "not-valid" : "")
                      }
                    >
                      <label className="input-label">
                        {t("confirm_password")}
                      </label>
                      <input
                        type="password"
                        name="confirmPassword"
                        id="confirmPassword"
                        className="form-control"
                        placeholder={t("confirm_password")}
                        value={this.state.confirmPassword}
                        maxLength="50"
                        onChange={this.handleConfirmPassword}
                      />
                      {this.state.errors.confirmPassword && (
                        <div className="alert alert-danger" role="alert">
                          {t(this.state.errors.confirmPassword)}
                        </div>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="btn min_outlin_btn active"
                      disabled={!this.state.formIsValid}
                      id="update-password"
                    >
                      {t("update_password")}{" "}
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                  </form>
                </div>
              </div>
            </section>
          )}
          <section className="login_form">
            {this.state.isSuccess && (
              <SuccessMessage
                userName={this.props.userName}
                setShowResetPassword={this.props.setShowResetPassword}
              />
            )}
          </section>
        </div>
      </div>
    );
  }
}
export default withTranslation()(ResetPassword);